import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/application/src/app/(dach)/weatherGuide/layout.tsx");
